import './documents_types';
import './documents_types-list';
import './documents_types-edit'; 